module.exports = __webpack_public_path__ + "static/img/12.eb51213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/12.png
// module id = eYOQ
// module chunks = 0